const hotKeywords = ["# 年度音综收官", "# 折叠屏新品", "# 文创雪糕", "# 摸鱼经济学", "# 小众旅行地", "# 国漫续作"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=a%20vibrant%20editorial%20illustration%20of%20watermelon%20slices%20and%20citrus%20splashes%20on%20a%20soft%20cream%20background%2C%20juicy%20red%20pulp%20and%20fresh%20green%20rind%20color%20palette%2C%20playful%20modern%20flat%20design%20with%20gentle%20gradients%2C%20fruits%20floating%20in%20the%20air%2C%20clean%20composition%2C%20no%20text&width=1600&height=900&seq=baogua-hero-x1&orientation=landscape"
          alt="爆瓜网吃瓜爆料平台的西瓜主题创意插画背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#fbf7ef]/70 via-[#fbf7ef]/40 to-[#fbf7ef]"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-28 md:pt-40 pb-16 md:pb-24 w-full">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/90 border border-emerald-600/20 px-4 py-1.5 text-sm text-emerald-700 font-medium">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#ff4d3d] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#ff4d3d]"></span>
            </span>
            今日已有 38000+ 条新鲜爆料上墙
          </span>

          <h1 className="mt-6 font-serif-cn text-4xl md:text-6xl leading-[1.15] md:leading-[1.1] font-black text-[#201d1a]">
            你的线索，就是
            <span className="text-[#ff4d3d]">下一个大瓜</span>
            <br className="hidden sm:block" />
            和千万吃瓜群众一起<span className="text-emerald-600">上热搜</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-[#201d1a]/70 leading-relaxed max-w-2xl">
            爆瓜网开放用户投稿与互动：上传爆料直达专区，网友评论留言实时讨论。围观娱乐资讯、消费避坑、职场见闻与生活趣事，分享你的所见所闻，让真实的声音被更多人听见。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#submit"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#ff4d3d] px-7 py-3.5 font-semibold text-white hover:bg-[#e63e30] transition-colors whitespace-nowrap"
            >
              <i className="ri-upload-cloud-2-line w-5 h-5 flex items-center justify-center"></i>
              我要投稿爆料
            </a>
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 px-7 py-3.5 font-semibold text-white hover:bg-emerald-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-fill w-5 h-5 flex items-center justify-center"></i>
              先来吃瓜围观
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="text-sm text-[#201d1a]/50 flex items-center gap-1">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i> 实时热议：
            </span>
            {hotKeywords.map((kw) => (
              <span
                key={kw}
                className="rounded-full bg-white/85 border border-amber-900/10 px-3.5 py-1.5 text-[13px] text-[#201d1a]/75 hover:border-[#ff4d3d]/40 hover:text-[#ff4d3d] transition-colors cursor-pointer whitespace-nowrap"
              >
                {kw}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}